<template>
  <!--企业认证管理-->
  <div class="enterprise-auth">
    <!--筛选-->
    <el-row type="flex" class="row">
      <el-col :span="7"></el-col>
      <el-col :span="4">
        <el-select
          v-model="param.column"
          placeholder="请选择"
          size="small"
          style="width: 165px"
        >
          <el-option label="企业名称" value="name" />
          <el-option label="企业邮箱" value="email" />
          <el-option label="证件号" value="business_license" />
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-input
          size="small"
          v-model="param.value"
          placeholder="查询内容"
          style="width: 210px"
        />
      </el-col>
      <el-col :span="5">
        <el-date-picker
          v-model="selectParamDateArr"
          value-format="yyyy-MM-dd"
          :default-time="['00:00:00', '23:59:59']"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          style="width: 100%"
        />
      </el-col>
      <el-col :span="3" class="text-right">
        <el-row type="flex">
          <el-col :span="12">
            <el-button @click="selectTableList" size="small">查询</el-button>
          </el-col>
          <el-col :span="12">
            <el-button @click="rest" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!--列表-->
    <el-table
      v-loading="loading"
      class="data-list"
      :data="tableList"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '500',
      }"
    >
<!--      <el-table-column type="selection" width="55" />-->
      <el-table-column label="企业名称" prop="name" show-overflow-tooltip />
      <el-table-column label="企业邮箱" prop="email" show-overflow-tooltip />
      <el-table-column
        label="证件号"
        prop="businessLicense"
        show-overflow-tooltip
      />
      <el-table-column label="注册时间" prop="createTime" />
      <el-table-column
        :label="statusFilterLabel"
        :filter-multiple="false"
        prop="status"
        :filters="[
          { text: '未申请', value: '0' },
          { text: '待审核', value: '1' },
          { text: '审核通过', value: '3' },
          { text: '审核未通过', value: '2' },
        ]"
        :filter-method="filterTag"
        :filtered-value="statusFilterValue"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">未申请</span>
          <span v-if="scope.row.status == 1">待审核</span>
          <span v-if="scope.row.status == 3">审核通过</span>
          <span v-if="scope.row.status == 2">审核未通过</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <template v-if="scope.row.status == 2">
            <a
              @click="queryEntAuthDetail(scope.row.userId, true)"
              href="javascript:void (0)"
              class="options-sty color-success pointer"
              >修改</a
            >
            &nbsp;&nbsp;
            <a
              @click="showReason(scope.row)"
              href="javascript:void (0)"
              class="options-sty color-success pointer"
              >查看原因</a
            >
          </template>
          <template v-else-if="scope.row.status != 2">
            <a
              @click="queryEntAuthDetail(scope.row.userId, false)"
              href="javascript:void (0)"
              class="color-danger pointer"
              >查看</a
            >
           <!-- <a
            @click="certifyManage(scope.row.userId)"
            v-if="+scope.row.status === 3"
            href="javascript:void (0)"
            class="color-success pointer"
            style="margin-left: 10px"
            >硬key证书</a> -->
          </template>
        </template>
      </el-table-column>
      <no-data text="暂无数据" slot="empty" />
    </el-table>

    <!--分页-->
    <el-row class="pageation row">
      <el-col :span="6">
        <div style="height: 20px"><!--占位--></div>
      </el-col>
      <el-col :span="18" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="param.itemPage"
          :page-sizes="[10, 20, 50, 100]"
          :pager-count="5"
          :page-size="param.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="param.total"
        />
        <el-go
          :page-size="param.pageSize"
          :total="param.total"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
    <!--显示列表的企业详情 或修改-->
    <el-dialog
      title="企业信息"
      :visible.sync="showDetailDialog"
      class="dialog-entdetail"
    >
      <ul v-if="entAuthDetail">
        <li>
          <p class="color-success text-right">邮箱：</p>
          <p class="info">{{ entAuthDetail.email }}</p>
          <input @change="handleInputChange" type="file" ref="updateFile" />
        </li>
        <li>
          <p class="color-success text-right">企业名称：</p>
          <p class="info">{{ entAuthDetail.name }}</p>
          <p v-if="isChangeInfo">
            <a
              @click="openInputDialog('name', '企业名称')"
              href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">来源名称：</p>
          <p class="info">{{ entAuthDetail.sourceName }}</p>
          <p v-if="isChangeInfo">
            <a
              @click="openInputDialog('sourceName', '来源名称')"
              href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">企业联系人：</p>
          <p class="info">{{ entAuthDetail.linkman }}</p>
          <p v-if="isChangeInfo">
            <a
              @click="openInputDialog('linkman', '企业联系人')"
              href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">企业联系人手机：</p>
          <p class="info">{{ entAuthDetail.mobilePhone }}</p>
          <p v-if="isChangeInfo">
            <a
              @click="openInputDialog('mobilePhone', '企业联系人手机')"
              href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">法人姓名：</p>
          <p class="info">{{ entAuthDetail.legalName }}</p>
          <p v-if="isChangeInfo">
            <a
              @click="openInputDialog('legalName', '法人姓名')"
              href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">法人手机号：</p>
          <p class="info">{{ entAuthDetail.legalMobilePhone }}</p>
          <p v-if="isChangeInfo">
            <a
              @click="openInputDialog('legalMobilePhone', '法人手机号')"
              href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">法人身份证号：</p>
          <p class="info">{{ entAuthDetail.legalCard }}</p>
          <p v-if="isChangeInfo">
            <a
              @click="openInputDialog('legalCard', '法人身份证号')"
              href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">营业执照注册号：</p>
          <p class="info">{{ entAuthDetail.businessLicense }}</p>
          <p v-if="isChangeInfo">
            <a
              @click="openInputDialog('businessLicense', '营业执照注册号')"
              href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">营业执照扫描件：</p>
          <p class="info">
            <template v-if="entAuthDetail.businessLicenseImg">
              <a
                @click="
                  showFileDetail(
                    entAuthDetail.businessLicenseImg,
                    '营业执照扫描件'
                  )
                "
                href="javascript:void(0)"
                >点击查看</a
              >
            </template>
          </p>
          <p v-if="isChangeInfo">
            <a
              @click="updateFileInfo('businessLicenseImg')"
              href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">组织机构代码：</p>
          <p class="info">{{ entAuthDetail.organizationCode }}</p>
          <p v-if="isChangeInfo">
            <a
              @click="openInputDialog('organizationCode', '组织机构代码')"
              href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">税务登记证：</p>
          <p class="info">
            <template v-if="entAuthDetail.taxCertificateImg">
              <a
                @click="
                  showFileDetail(entAuthDetail.taxCertificateImg, '税务登记证')
                "
                href="javascript:void(0)"
                >点击查看</a
              >
            </template>
          </p>
          <p v-if="isChangeInfo">
            <a
              @click="updateFileInfo('taxCertificateImg')"
              href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">法人身份证：</p>
          <p class="info">
            <template v-if="entAuthDetail.frontLegalIdentityCard">
              <a
                @click="
                  showFileDetail(
                    entAuthDetail.frontLegalIdentityCard,
                    '法人身份证正面'
                  )
                "
                href="javascript:void(0)"
                >正面查看</a
              >
            </template>
            <template v-if="entAuthDetail.versonLegalIdentityCard">
              <a
                @click="
                  showFileDetail(
                    entAuthDetail.versonLegalIdentityCard,
                    '法人身份证反面'
                  )
                "
                href="javascript:void(0)"
                >反面查看</a
              >
            </template>
          </p>
          <p v-if="isChangeInfo">
            <a
              @click="updateFileInfo('frontLegalIdentityCard')"
              href="javascript: void (0)"
              >正面修改</a
            >
            <a
              @click="updateFileInfo('versonLegalIdentityCard')"
              href="javascript: void (0)"
              >反面修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">委托人身份证：</p>
          <p class="info">
            <template v-if="entAuthDetail.frontAgentIdentityCard">
              <a
                @click="
                  showFileDetail(
                    entAuthDetail.frontAgentIdentityCard,
                    '委托人身份证正面'
                  )
                "
                href="javascript:void(0)"
                >正面查看</a
              >
            </template>
            <template v-if="entAuthDetail.versonAgentIdentityCard">
              <a
                @click="
                  showFileDetail(
                    entAuthDetail.versonAgentIdentityCard,
                    '委托人身份证反面'
                  )
                "
                href="javascript:void(0)"
                >反面查看</a
              >
            </template>
          </p>
          <p v-if="isChangeInfo">
            <a
              @click="updateFileInfo('frontAgentIdentityCard')"
              href="javascript: void (0)"
              >正面修改</a
            >
            <a
              @click="updateFileInfo('versonAgentIdentityCard')"
              href="javascript: void (0)"
              >反面修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">授权委托书：</p>
          <p class="info">
            <template v-if="entAuthDetail.agentAttorneyCard">
              <a
                @click="
                  showFileDetail(entAuthDetail.agentAttorneyCard, '授权委托书')
                "
                href="javascript:void(0)"
                >点击查看</a
              >
            </template>
          </p>
          <p v-if="isChangeInfo">
            <a
              @click="updateFileInfo('agentAttorneyCard')"
              href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
        <li>
          <p class="color-success text-right">申请表扫描件：</p>
          <p class="info">
            <template v-if="entAuthDetail.applyTableImg">
              <a
                @click="
                  showFileDetail(entAuthDetail.applyTableImg, '申请表扫描件')
                "
                href="javascript:void(0)"
                >点击查看</a
              >
            </template>
          </p>
          <p v-if="isChangeInfo">
            <a
              @click="updateFileInfo('applyTableImg')"
              href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
<!--        <li>-->
<!--          <p class="color-success text-right">企业介绍：</p>-->
<!--          <p class="info">{{ entAuthDetail.enterpriseIntroduce }}</p>-->
<!--          <p v-if="isChangeInfo">-->
<!--            <a-->
<!--              @click="openInputDialog('enterpriseIntroduce', '企业介绍')"-->
<!--              href="javascript: void (0)"-->
<!--              >修改</a-->
<!--            >-->
<!--          </p>-->
<!--        </li>-->
<!--        <li>-->
<!--          <p class="color-success text-right">企业LOGO：</p>-->
<!--          <p class="info">-->
<!--            <template v-if="entAuthDetail.enterpriseLogoPath">-->
<!--              <a-->
<!--                @click="-->
<!--                  showFileDetail(entAuthDetail.enterpriseLogoPath, '企业LOGO')-->
<!--                "-->
<!--                href="javascript:void(0)"-->
<!--                >点击查看</a-->
<!--              >-->
<!--            </template>-->
<!--          </p>-->
<!--          <p v-if="isChangeInfo">-->
<!--            <a-->
<!--              @click="updateFileInfo('enterpriseLogoPath')"-->
<!--              href="javascript: void (0)"-->
<!--              >修改</a-->
<!--            >-->
<!--          </p>-->
<!--        </li>-->
        <li>
          <p class="color-success text-right">企业签章：</p>
          <p class="info">
            <template
              v-if="
                entAuthDetail.workedImg ||
                entAuthDetail.enterpriseUserEsignature
              "
            >
              <a
                @click="
                  showFileSealDetail(
                    entAuthDetail.workedImg,
                    '企业签章',
                    entAuthDetail.enterpriseUserEsignature
                  )
                "
                href="javascript:void(0)"
                >点击查看</a
              >
            </template>
          </p>
          <p v-if="isChangeInfo">
            <a @click="updateFileInfo('workedImg')" href="javascript: void (0)"
              >修改</a
            >
          </p>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="showDetailDialog = false"
          type="success"
          size="small"
          class="btn"
        >取消</el-button
        >
        <el-button
          @click="updateEntInfo"
          v-if="isChangeInfo"
          type="danger"
          size="small"
          class="btn"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!--显示图片dialog-->
    <el-dialog
      :title="fileShow.title"
      :visible.sync="fileShow.showDialg"
      append-to-body
      width="800px"
      class="dialog-fileshow"
    >
      <div class="img-box">
        <img :src="fileShow.fileUrl" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="fileShow.showDialg = false"
          type="danger"
          size="small"
          class="btn"
          >关闭</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="证书详情"
      :visible.sync="showCertifyManage"
      append-to-body
      width="800px"
      class="dialog-fileshow"
    >
      <div class="certify-manage">
        <h3><i></i>企业信息</h3>
        <el-row class="row">
          <el-col :span="12"> 单位名称：{{ certifyManageInfo.name }} </el-col>
          <el-col :span="12">
            法人代表：{{ certifyManageInfo.legalName }}
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12">
            单位证件号：{{ certifyManageInfo.businessLicense }}
          </el-col>
          <el-col :span="12">
            联系地址：{{ certifyManageInfo.contactAddress }}
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12"> 联系人：{{ certifyManageInfo.linkman }} </el-col>
          <el-col :span="12">
            联系电话：{{ certifyManageInfo.mobilePhone }}
          </el-col>
        </el-row>
        <h3><i></i>证书信息</h3>
        <p class="row" v-show="certifyManageInfo.signRefcode">
          序列号：{{ certifyManageInfo.signRefcode }}
        </p>
        <div class="btn-box">
          <el-button @click="downCertify()" type="danger" size="small"
            >下载证书到硬key</el-button
          >
        </div>
      </div>
    </el-dialog>
    <object
      id="mhws"
      width="0"
      height="0"
      classid="clsid:235862A1-53A1-4774-A67F-A23E54B41C50"
    ></object>
  </div>
</template>

<script>
import {
  fileOperShowParam2Str,
  ApiMethods
} from "../../assets/js/http-serve/http-methods";
import EntAuthController from "../../assets/js/http-serve/entAuthController";
import ElGo from "../go/Go";

const updateEntParamInfo = {
  businessLicenseImg: null,
  taxCertificateImg: null,
  frontLegalIdentityCard: null,
  versonLegalIdentityCard: null,
  frontAgentIdentityCard: null,
  versonAgentIdentityCard: null,
  agentAttorneyCard: null,
  applyTableImg: null,
  enterpriseLogoPath: null,
  workedImg: null,
  userId: null,
  name: null,
  sourceName: null,
  linkman: null,
  mobilePhone: null,
  businessLicense: null,
  enterpriseIntroduce: null,
  organizationCode: null,
  legalName: null,
  legalCard: null,
  legalMobilePhone: null
};

export default {
  components: { ElGo },
  data () {
    return {
      loading: false,
      tableList: [],
      param: {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        column: null,
        value: null,
        beginDate: null,
        endDate: null,
        status: null
      },
      selectParamDateArr: [],
      // tab筛选和select选择保存变量
      statusFilterValue: [],
      statusFilterLabel: "全部",
      // 详情
      entAuthDetail: null,
      showDetailDialog: false,
      isChangeInfo: true,
      // 文件图片显示
      fileShow: { showDialg: false, fileUrl: "", title: "" },
      // 企业信息修改参数
      updateEntParam: JSON.parse(JSON.stringify(updateEntParamInfo)),
      // 加载提示
      loading: false,
      showCertifyManage: false,
      certifyManageInfo: {
        signAuthcode: null,
        signRefcode: null
      }
    };
  },
  beforeMount () {
    this.getTableList();
  },
  watch: {
    statusFilterValue: function (val) {
      if (val.length) {
        this.param.status = val[0];
        switch (val[0]) {
          case "0":
            this.statusFilterLabel = "未申请";
            break;
          case "1":
            this.statusFilterLabel = "待审核";
            break;
          case "2":
            this.statusFilterLabel = "审核未通过";
            break;
          case "3":
            this.statusFilterLabel = "审核通过";
            break;
          default:
            this.param.status = null;
            this.statusFilterLabel = "全部";
        }
        this.getTableList();
      } else {
        this.param.status = null;
        this.getTableList();
        this.statusFilterLabel = "全部";
      }
    }
  },
  methods: {
    getCertify () {
      ApiMethods.CertApplyController.givenEnt({
        userId: this.certifyManageInfo.userId
      }).then(res => {
        if (!res.success) return this.$message.error(res.description);
        this.$set(
          this.certifyManageInfo,
          "signAuthcode",
          (res.data || {}).signAuthcode
        );
        this.$set(
          this.certifyManageInfo,
          "signRefcode",
          (res.data || {}).signRefcode
        );
        this.$set(this.certifyManageInfo, "applyStatus", 1);
        this.$message.success(res.description || "证书申请成功");
      });
    },
    downCertify () {
      if (this.loading) return;
      this.loading = true;
      let mhwskeycount,
        conType,
        rv = 0;
      try {
        mhwskeycount = mhws.IsHaveKey();
      } catch (e) {
        return this.$message.error(
          "当前浏览器不支持证书下载，请使用IE11浏览器"
        );
      }
      if (mhwskeycount < 0)
        return this.$message.error("获取存储介质信息失败,请安装最新控件程序!");
      if (+mhwskeycount === 0) return this.$message.error("请插入存储介质");
      if (mhwskeycount > 1)
        return this.$message.error("检测到多个key,请只保留一个存储介质!");
      +mhwskeycount === 1 && (conType = mhws);
      window.cu_icnumber = conType.GetUSBKeyItem(1);

      //这个地方验证一下Key的PIN码;
      var res = conType.VerifyPIN(window.cu_icnumber, 2, "111111");
      if (+res !== 0) return this.$message.error("验证Key的PIN码失败！");

      var enumContainer = conType.EnumContainer(window.cu_icnumber);
      if (enumContainer != "") {
        //初次下载需删除全部内容
        //补下不可以删除签名容器
        var temp = enumContainer.split(";");
        for (var i = 0; i < temp.length; i++) {
          rv = -1;
          rv = conType.DeleteContainer(window.cu_icnumber, temp[i]);
        }
        var temp = enumContainer.split(";");
        for (var i = 0; i < temp.length; i++) {
          rv = -1;
          rv = conType.DeleteContainer(window.cu_icnumber, temp[i]);
        }
      }
      rv = conType.CreateContainer(window.cu_icnumber, "CTAIS001");
      if (rv != 0) return this.$message.error("创建签名证书容器失败!");

      ApiMethods.CertApplyController.givenEnt({
        userId: this.certifyManageInfo.userId
      })
        .then(res => {
          if (!res.success) return this.$message.error(res.description);
          const dn = res.data; //dn p10的申请信息
          window.p10 = conType.GenP10(
            window.cu_icnumber,
            "CTAIS001",
            dn,
            2,
            1024
          );
          if (window.p10 == "") return this.$message.error("生成pkcs10失败!");
          this.$confirm("你确定已插入硬key,现在就下载数字证书吗?").then(() => {
            ApiMethods.CertApplyController.downCert({
              userId: this.certifyManageInfo.userId,
              cuIcnumber: window.cu_icnumber,
              p10: window.p10
            })
              .then(res => {
                if (!res.success) return this.$message.error(res.description);
                const signCertX509 = res.data.signCertX509; //签名证书
                rv = conType.ImportCert(
                  window.cu_icnumber,
                  "CTAIS001",
                  signCertX509,
                  2
                );
                if (+rv !== 0) return this.$message.error("安装签名证书失败!");
                this.$message.success("安装加密证书成功");
              })
              .finally(() => (this.loading = false));
          });
        })
        .catch(() => (this.loading = false));
    },
    certifyManage (userId) {
      ApiMethods.CertApplyController.certInfo({ userId: userId }).then(res => {
        if (!res.success) return this.$message.error(res.description);
        this.certifyManageInfo = res.data;
        this.certifyManageInfo.userId = userId;
        this.showCertifyManage = true;
      });
    },

    // 修改信息上传文件
    updateFileInfo (key, title) {
      let objInput = this.$refs.updateFile;
      objInput.setAttribute("data-key", key);
      objInput.click();
    },
    handleInputChange (el) {
      el = el.target;
      let key = el.dataset.key;
      let file = el.files[0];
      this.updateEntParam[key] = file;
      el.value = "";
    },
    // 修改信息的文字弹窗输入框
    openInputDialog (key, title) {
      let validPattern = null;
      let validMessage = "";
      if (key === "mobilePhone" || key === "legalMobilePhone") {
        validPattern = /^1[1-9]\d{9}$/;
        validMessage = "手机号格式不正确";
      } else if (key === "legalCard") {
        validPattern = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
        validMessage = "身份证号码格式不正确";
      } else if (key === "businessLicense") {
        validPattern = /^[A-Z0-9]{12,18}$/;
        validMessage = "营业执照注册号格式不正确";
      } else if (key === "organizationCode") {
        validPattern = /^[a-zA-Z0-9]{8}-?[a-zA-Z0-9]$/;
        validMessage = "组织机构代码格式不正确";
      } else {
        validPattern = /^.{1,200}$/;
        validMessage = "字符长度为1-200个字符";
      }

      this.$prompt(title, title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: validPattern,
        inputErrorMessage: validMessage,
        inputValue: this.entAuthDetail[key]
      })
        .then(({ value }) => {
          this.updateEntParam[key] = value;
          this.entAuthDetail[key] = value;
        })
        .catch(() => {
          console.log("取消修改");
        });
    },
    // 更新企业信息
    updateEntInfo () {
      this.showDetailDialog = false;
      if (!this.isChangeInfo) return;
      EntAuthController.updateEntAuthInfo(this.updateEntParam)
        .then(() => {
          this.$message({ message: "信息修改成功", type: "success" });
        })
        .catch(err => {
          this.$message({
            message: err.description || "信息修改失败",
            type: "warning"
          });
        });
    },
    // 显示章
    showFileSealDetail (str, title, deafultSeal) {
      let url = null;
      if (deafultSeal) {
        url = "data:image/png;base64," + deafultSeal;
      } else {
        url = fileOperShowParam2Str(str);
      }
      this.fileShow = {
        fileUrl: url,
        title: title,
        showDialg: true
      };
    },
    // 显示文件
    showFileDetail (str, title) {
      let url = fileOperShowParam2Str(str);
      this.fileShow = {
        fileUrl: url,
        title: title,
        showDialg: true
      };
    },
    /** 查看原因 */
    showReason(row){
      this.$alert(row.reason || '暂无原因', '未通过原因', {
          confirmButtonText: '确定',
          callback: action => {}
        });
    },
    //获取详情
    queryEntAuthDetail (id, ischange) {
      if (!id) return;
      // 企业信息修改参数重置
      this.updateEntParam = JSON.parse(JSON.stringify(updateEntParamInfo));
      this.isChangeInfo = ischange;
      EntAuthController.postFindEntAuthByUserId(id)
        .then(data => {
          this.entAuthDetail = data.data;
          this.showDetailDialog = true;
          this.updateEntParam.userId = id;
        })
        .catch(err => {
          this.$message({ message: "没有找到该企业的信息", type: "warning" });
        });
    },
    // 重置
    rest () {
      this.param = {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        column: null,
        value: null,
        beginDate: null,
        endDate: null,
        status: null
      };
      this.selectTableList();
    },
    // 筛选查询
    selectTableList () {
      this.param.itemPage = 1;
      this.param.pageSize = 10;
      this.getTableList();
    },
    // 获取企业认证管理列表
    getTableList () {
      let param = JSON.parse(JSON.stringify(this.param));
      if (this.selectParamDateArr && this.selectParamDateArr.length == 2) {
        param.beginDate = this.selectParamDateArr[0];
        param.endDate = this.selectParamDateArr[1];
      }
      this.loading = true;
      EntAuthController.postEntAuthFindByPage(param)
        .then(data => {
          this.$parent.badge = data.total;
          this.param.itemPage = data.pageNum;
          this.param.pageSize = data.pageSize;
          this.param.total = data.total;
          this.tableList = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`);
      this.param.itemPage = 1;
      this.param.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`);
      this.param.itemPage = val;
      this.getTableList();
    },
    filterTag: function (row, column) {
      this.param.status = row;
      return row === column.status;
    },
    handleSelectionChange: function (val) { }
  },
  name: "ent-auth"
};
</script>
<style>
.el-button + .el-button {
  margin-left: 0px;
}
</style>

<style lang="less" scoped>
.options-sty{
  color:#290202;
}
.certify-manage {
  h3 {
    i {
      display: inline-block;
      width: 5px;
      height: 16px;
      background-color: #ec1c1c;
      position: relative;
      top: 3px;
      margin-right: 5px;
    }
  }

  .row {
    margin: 15px 0;
  }

  .btn-box {
    margin-top: 10px;
  }
}

.dialog-fileshow {
  .img-box {
    height: 480px;
    text-align: center;

    img {
      max-width: 100%;
      max-height: 100%;
      vertical-align: top;
    }
  }

  .dialog-footer {
    padding: 0;
    margin-bottom: -10px;

    .btn {
      width: auto;
    }
  }
}

.dialog-entdetail {
  ul {
    font-size: 13px;
    background-color: #ecf0f5;
    padding: 10px 20px 10px;
    border-top: 1px solid #cccccc;
    overflow: hidden;

    li {
      overflow: hidden;
    }

    input[type="file"] {
      display: none;
    }

    p {
      box-sizing: border-box;
      width: 140px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 23px;
      height: 23px;
      padding: 0px;
      margin: 0px;
      float: left;

      a {
        display: inline-block;
        margin-right: 5px;
        outline: none;
      }
    }

    p.info {
      width: 200px;
    }

    p.text-right {
      border-bottom: 1px solid #ffffff;
    }
  }

  .dialog-footer {
    padding-bottom: 0;
    text-align: center;
    margin-bottom: -10px;
    padding-top: 10px;

    .btn {
      width: 235px;
    }
  }
}

.pageation {
  padding: 30px 10px 20px 10px;
  border-top: 0;
}

.dialog-footer {
  padding-bottom: 20px;

  .btn {
    width: 30%;
  }
}
</style>



// WEBPACK FOOTER //
// components/ent-access/entAuth.vue